import { createSlice } from '@reduxjs/toolkit';
import { t } from '~app/core/AppBundleContext';
import { Model } from '~app/core/model';
import Diagram from '~app/models/Diagram';
import * as DocumentOps from './ops';

const documentSlice = createSlice({
  name: 'document',
  initialState: null,
  reducers: {
    modelLoaded(state, { payload }) {
      return payload.doc;
    },

    closeModel(state) {
      return null;
    },

    /*
    setEditMode(state, {payload}) {
      const {mode} = payload;
      if (!defined(state.editMode) && !defined(mode)) return state;
      if (state.editMode === mode) return state;
      let inst = Model.deserialize(state, Diagram);
      inst = inst.setEditMode(mode);
      inst = Model.serialize(inst);
      Arrows.init(inst);
      return inst;
    },
    */

    // create an action/reducer pair for each of the DocumentOps
    ...Object.keys(DocumentOps).reduce((obj, key) => {
      obj[key] = (state, { payload }) => {
        DocumentOps[key](state, payload);
        if (process.env.NODE_ENV === 'development') {
          // In development, check the model for consistency after every change
          const [ok, ...err] = Model.deserialize(state, Diagram).getIsValid();
          if (!ok) {
            throw new Error(t(...err));
          }
        }
        state.labelBankItems = state.allLabelBankItems.filter(
          key => !(key in state.workingModel?.nodes),
        );
        if (key !== 'updateAnchorDataImpl') {
          state.isModified = true;
        }
      };
      return obj;
    }, {}),
  },
  extraReducers: {
    'saveLoad/fileSaved': state => {
      state.isModified = false;
    },
  },
});

export default documentSlice;
